
import {  FiEdit, FiPlusCircle } from "react-icons/fi"
import {Link} from "react-router-dom"

import React, { useEffect, useState } from 'react';
import Alert from './Alert';
import ItemWConf from './ItemWConf';
import ItemYORP from './ItemYORP';

import { db } from '../functions/firebaseFunctions'
export default function ServicesTab(props) {
    const {  uid, setUserState, setTab, serBks } = props;
    const [Err, setErr] = useState(null);
    const [alert, setAlert] = useState(null);
    const [actSs, setActSs] = useState([]);

    useEffect(() => {
        db.collection('services')
          .doc(uid)
          .onSnapshot((querySnapshot) => {
            if (querySnapshot.exists) {
              const services = querySnapshot.data().services?.map(doc => ({
                name: doc.servicetype,
                price: doc.price
              }));
              setActSs(services || []);
            }
          });
      }, []);

    return (
        <div className='tab' >
            {alert && <Alert title="Are you sure?"
                setAlert={setAlert}
                comment={alert.comment}
                options={alert.options}
            />}
            {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
            <Link to="/Profile/edit/" style={{alignSelf: 'center', color: 'white'}}>
                Edit artist's info
                <FiEdit style={{marginLeft: 10}}/>
            </Link>
            <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
            {console.log('serBks', serBks)}
            {serBks && <React.Fragment>
                <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                <div className='centered' >
                    <p style={{  textAlign: 'center', color: 'white' }}>Bookings:</p>
                    <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                    {serBks && serBks.map(item => <ItemWConf key={item.eventId} item={item}
                        link={() => { console.log('Event', { uid: item.user, eventId: item.eventId }); }}
                        onAccept={() => {

                            db.collection('bookings').doc(item.eventId).collection('etts').doc(uid).update({ status: 'Booked' }).then(() => {
                                // setUserState(null); 
                                setTab('Services');
                            }).catch(e => { setErr(e); });
                        }}
                        onDelete={() => {

                            db.collection('bookings').doc(item.eventId).collection('etts').doc(uid).update({ status: 'Deleted' }).then(() => {
                                // setUserState(null);
                            }).catch(e => { setErr(e); });
                        }}
                        onDecline={() => {

                            db.collection('bookings').doc(item.eventId).collection('etts').doc(uid).update({ status: 'Canceled' }).then(() => {
                                // setUserState(null);
                            }).catch(e => { setErr(e); });

                        }}
                        setAlert={setAlert}
                    />)}
                </div>
            </React.Fragment>}
            <Link  to={`/edit_service/${'new'}&${undefined}`}  style={{alignSelf: 'center', color: 'white'}}>
                Add New Service
                <FiPlusCircle style={{marginLeft: 10}}/>
            </Link>
            {actSs ? <React.Fragment>
                <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                <div className="centered" style={{display: 'flex', flexDirection:  'column'}}>
                    <p className='dashboardLink' style={{cursor: 'default', marginBlockEnd: 5}}>Active Services:</p>
                    {console.log('length', actSs.length)}
                    <div className="ServiceTabDisplay" style={{cursor: 'pointer', width: '100%', flexDirection: 'column', gridTemplateColumns: actSs.length === 2  ? '1fr 1fr' : actSs.length === 4 ? '1fr 1fr' : actSs.length < 2 ? '1fr' : '1fr 1fr 1fr', gap: 5}}>
                    {actSs.map(actS => 
                        <div key={actS.name}>
                            <Link to={`/edit_service/${actS.name ? actS.name : 'new'}&${actS.price ? actS.price : undefined}`}>
                                <div className='ServiceTabButtons' style={{borderWidth: 2, borderStyle: "solid",borderRadius: 8, animation: 'colorYORP 8s linear infinite', width: '100%'}}>
                                    <p  style={{textAlign: 'center'}}>{actS.name}</p>
                                    {console.log(actS.name, actS.price)}
                                </div>    
                            </Link>
                        </div>
                    )}
                    {console.log('actSs', actSs)}
                    </div>
                </div>
            </React.Fragment> :
                <p style={{ color: "var(--yel)", textAlign: 'center', margin: 5 }}>Begin by adding a service that you could offer</p>}
        </div>
    );
}
